/* 🤖 this file was generated by svg-to-ts */
export const emperorIconPowerButton: {
  name: 'power_button';
  data: string;
} = {
  name: 'power_button',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M14.9996 5.589V7.81201C16.7906 8.85201 17.9996 10.786 17.9996 13C17.9996 16.309 15.3086 19 11.9996 19C8.6906 19 5.9996 16.309 5.9996 13C5.9996 10.785 7.2086 8.85201 8.9996 7.81201V5.589C6.0716 6.77901 3.99961 9.65001 3.99961 13C3.99961 17.411 7.58861 21 11.9996 21C16.4106 21 19.9996 17.411 19.9996 13C19.9996 9.65001 17.9276 6.77901 14.9996 5.589Z"/><path d="M12.9992 3H10.9992V11H12.9992V3Z"/></svg>`,
};
